// extracted by mini-css-extract-plugin
export default {"footer":"SLCtM","disclaimer":"AS3B3","disclaimerLink":"CKATA"};